export const formatPrice = (p: number) => {
  return (p / 100).toFixed(2).replace(/\.00$/, '')
}
